import { useEffect, useRef } from 'react';

export function TriggerEffectOnce(props: { effect: () => void }) {
  const effectRef = useRef(props.effect);
  useEffect(() => {
    effectRef.current();
  }, []);
  return null;
}
